import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { styled, TextField } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme: any) => ({
  styledDatePicker: {
    "& .react-datepicker__triangle": {
      left: "-190px !important",
      "&::after": {
        borderBottomColor: `${theme.palette.common.white} !important`
      }
    },
    "& .react-datepicker__header": {
      backgroundColor: `${theme.palette.common.white} !important`,
      borderBottom: 0
    }
  }
}));

const StyledTextField = styled(TextField)(() => ({
  width: "100%",
  padding: "8px 0px",
  "& .MuiInput-input": {
    padding: "5px 0px"
  },
  "& .MuiInputBase-root": {
    height: "100%",
    fontSize: 14,
    "& .MuiIconButton-root": { display: "none" }
  }
}));

interface DatePickerInterface {
  onChange: (value: any, keyboardInputValue?: string | undefined) => void;
  value: any;
  placeholder?: string;
}
const CustomDatePicker = ({
  onChange,
  value,
  placeholder
}: DatePickerInterface) => {
  const classes = useStyles({});
  const ExampleCustomInput = (
    <StyledTextField
      autoComplete="off"
      size="small"
      variant="standard"
      InputLabelProps={{
        color: "secondary",
        disableAnimation: true,
        shrink: true
      }}
      inputProps={{
        style: { textAlign: "center" }
      }}
    />
  );
  return (
    <DatePicker
      wrapperClassName={classes.styledDatePicker}
      calendarClassName={classes.styledDatePicker}
      placeholderText={placeholder}
      selected={value}
      onChange={(date: any) => onChange(date)}
      customInput={ExampleCustomInput}
    />
  );
};
export default CustomDatePicker;
